import { axiosClient } from "@/app/client/axiosClient";
import { LocationPosition } from "@/types/LocationPosition";

export const makeGoogleMapConfirmRouteUrl = (
  latitude: string,
  longitude: string
) => {
  return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
};

export const getLocationPosition = async (
  address: string
): Promise<LocationPosition> => {
  const res = await axiosClient.get(
    "https://maps.googleapis.com/maps/api/geocode/json",
    {
      params: {
        address,
        key: process.env.VUE_APP_GOOGLE_MAP_API_KEY
      }
    }
  );
  return {
    latitude: res.data["results"][0]["geometry"]["location"]["lat"],
    longitude: res.data["results"][0]["geometry"]["location"]["lng"]
  };
};
